import { useEffect } from "react";
import { scrollToTop } from "@/lib/utils";
import BookingSection from "@/components/booking/BookingSection";

export default function BookingPage() {
  useEffect(() => {
    scrollToTop();
  }, []);
  
  return (
    <>
      <div className="pt-24 pb-12 bg-[#f8f9fa]">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1a365d] mb-4">Book a Consultation</h1>
            <div className="w-24 h-1 bg-[#7d9b76] mx-auto mb-6"></div>
            <p className="max-w-3xl mx-auto text-lg">
              Schedule a meeting with Sarah Willardsen to discuss your business's financial needs and discover how SW Accounting can help you achieve greater financial clarity and success.
            </p>
          </div>
        </div>
      </div>
      
      <BookingSection />
      
      <div className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-serif text-3xl font-bold text-[#1a365d] mb-6 text-center">What to Expect in Your Consultation</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="bg-[#f8f9fa] p-6 rounded-lg text-center">
                <div className="text-[#7d9b76] text-3xl mb-4">
                  <i className="fas fa-comments"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-2">Understanding Your Needs</h3>
                <p>We'll discuss your business's current financial state and your goals for the future.</p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg text-center">
                <div className="text-[#7d9b76] text-3xl mb-4">
                  <i className="fas fa-lightbulb"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-2">Custom Solutions</h3>
                <p>Sarah will recommend tailored accounting solutions specific to your business situation.</p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg text-center">
                <div className="text-[#7d9b76] text-3xl mb-4">
                  <i className="fas fa-file-contract"></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-2">Next Steps</h3>
                <p>You'll receive a clear plan of action and transparent pricing for the services you need.</p>
              </div>
            </div>
            
            <div className="bg-[#f8f9fa] p-6 rounded-lg mb-8">
              <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-4">Preparing for Your Meeting</h3>
              <p className="mb-4">To make the most of your consultation, consider preparing the following:</p>
              
              <ul className="space-y-2 mb-4">
                <li className="flex items-start">
                  <div className="text-[#7d9b76] mr-2 mt-1"><i className="fas fa-check-circle"></i></div>
                  <span>An overview of your current accounting processes</span>
                </li>
                <li className="flex items-start">
                  <div className="text-[#7d9b76] mr-2 mt-1"><i className="fas fa-check-circle"></i></div>
                  <span>Key financial pain points or challenges you're facing</span>
                </li>
                <li className="flex items-start">
                  <div className="text-[#7d9b76] mr-2 mt-1"><i className="fas fa-check-circle"></i></div>
                  <span>Goals you'd like to achieve with professional accounting support</span>
                </li>
                <li className="flex items-start">
                  <div className="text-[#7d9b76] mr-2 mt-1"><i className="fas fa-check-circle"></i></div>
                  <span>Questions about specific services or accounting processes</span>
                </li>
              </ul>
              
              <p>Don't worry if you don't have all of this information ready. The consultation is meant to be a starting point, and Sarah is happy to guide you through the process.</p>
            </div>
            
            <div className="bg-[#1a365d] text-white p-8 rounded-lg text-center">
              <h3 className="font-serif text-2xl font-bold mb-4">Need Immediate Assistance?</h3>
              <p className="mb-4">If you have urgent accounting needs or questions, you can reach out directly:</p>
              <div className="flex justify-center space-x-6">
                <a href="mailto:sarah@swaccountingpro.com" className="text-white hover:text-[#7d9b76] flex items-center transition-all duration-300">
                  <i className="fas fa-envelope mr-2"></i> Email Sarah
                </a>
                <a href="tel:8017916900" className="text-white hover:text-[#7d9b76] flex items-center transition-all duration-300">
                  <i className="fas fa-phone mr-2"></i> Call 801-791-6900
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
    </>
  );
}
